<div class="loading-indicator-overlay z-50" *ngIf="state.isLoading" @appearDisappear>
  <div class="relative flex w-full flex-col items-center justify-center text-neutral-500">
    <y42-logo-loader [widthInPixel]="70" />

    <span class="status-text" *ngIf="state.statusDescription" @appearDisappearWithHeight>
      {{ state.statusDescription }}
    </span>
  </div>
</div>
